<template>
    <div>
        <NavBar />
      <ContactHero />
      <ContactSection />
      <CallToAction />
      <FooterPage />
      </div>
</template>

<script>
import NavBar from '../components/NavBar.vue'
import ContactHero from'../components/ContactHero.vue'
import ContactSection from'../components/ContactSection.vue'
import CallToAction from'../components/CallToAction.vue'
import FooterPage from '../components/FooterPage.vue'

export default {
    components: {
      NavBar, ContactHero, ContactSection, CallToAction, FooterPage
    }
}
</script>

